import type { IDisplaySection } from "@lexicanon/shared"
import { Image, SimpleGrid, Title } from "@mantine/core"

interface IProps {
  section: IDisplaySection
  data: unknown
  artifacts?: Array<{ content: { url: string }; stepId: string }>
}

export function ImageGallerySection({ section, artifacts }: IProps): React.ReactElement | null {
  // Image gallery reads from artifacts, not from analysis JSON
  if (!artifacts || artifacts.length === 0) return null

  const images = artifacts.filter((a) => a.content?.url).map((a) => a.content.url)

  if (images.length === 0) return null

  return (
    <div>
      <Title order={4} mb="xs">
        {section.label}
      </Title>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="sm">
        {images.map((url) => (
          <Image key={`${section.id}-${url}`} src={url} radius="md" fit="cover" h={200} />
        ))}
      </SimpleGrid>
    </div>
  )
}
